module.exports = __webpack_public_path__ + "assets/security-logo-vertical-component.3d53ece6.svg";